import { CALL_API } from 'redux-api-middleware'
import { get } from 'utils/network'

export const fetchBilling = () => (dispatch, getState) => {
  if (getState().billing.get('hasFetched')) {
    return Promise.resolve()
  }

  const request = get(`/billing`)
  request.types = ['_REQ', 'BILL_GET_SUCC', 'NOTIF_FAIL']
  return dispatch({ [CALL_API]: request })
}



// WEBPACK FOOTER //
// ./src/containers/Billing/actions.js